
















import { computed, defineComponent } from "@vue/composition-api";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { $t } from "@/lib/i18nHelpers";
import { Tab } from "@/types";
import BasePage from "@/components/BasePage";
import BubbleTabs from "@/components/BubbleTabs/BubbleTabs.vue";
import EmptyContent from "@/components/EmptyContent";
import InfiniteScroll from "@/components/InfiniteScroll";
import PageTitle from "@/components/PageTitle";
import { notificationsTypes } from "../../config";
import getNotificationItem from "../NotificationItem/integrations";

export default defineComponent({
  name: "PageNotificationsView",
  components: { BubbleTabs, InfiniteScroll, BasePage, PageTitle, EmptyContent },
  props: {
    loading: { type: Boolean, required: true },
    scroll: { type: Boolean, required: true },
    notificationsList: { type: Array as () => Notification[], required: true },
    isCreator: { type: Boolean, required: true },
    activeFilter: { type: String, default: "all" },
  },
  setup(props) {
    const emptyNotifications = computed(() => !props.loading && !props.notificationsList.length);
    const tabs = computed<Tab[]>(() => {
      return Object.keys(notificationsTypes.value).flatMap(key => {
        return [{ text: $t(key), value: key }];
      });
    });
    const getComponent = (notification: Notification) => {
      return getNotificationItem(notification);
    };

    return { emptyNotifications, tabs, getComponent };
  },
});
